export const MODEL_DEFINITIONS = [
    {
        type: {
            value: 'Model for gene-level results (collapsing analysis)',
            rows: [
                {
                    model: 'flexdmg',
                    definition: {
                        list: [
                            'Non-synonymous (including protein-truncating variants, missense variants, in-frame insertions and deletions, splice acceptor variants and splice donor variants)',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'flexnonsyn',
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'flexnonsynmtr',
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
                {
                    model: 'ptv',
                    definition: {
                        list: [
                            'Protein-truncating variant',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'ptv5pcnt',
                    definition: {
                        description: 'Care should be taken in the interpretation of this model because it has a higher allele frequency threshold than other models and may therefore be more susceptible to confounding factors.',
                        list: [
                            'Protein-truncating variant',
                            'Less common (minor allele frequency ≤ 0.05 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'ptvraredmg',
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'PTVs must be moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            'Non-PTVs must be rare (minor allele frequency ≤ 0.0005 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'raredmg',
                    definition: {
                        list: [
                            'Missense variants',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Rare (minor allele frequency ≤ 0.0005 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'raredmgmtr',
                    definition: {
                        list: [
                            'Missense variants',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Rare (minor allele frequency ≤ 0.0005 within the cohort and within gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
                {
                    model: 'rec',
                    definition: {
                        description: 'Care should be taken in the interpretation of this model because it has a higher allele frequency threshold than most other models and may therefore be more susceptible to confounding factors. Additionally, be aware that the two qualifying variants in a gene in an individual may be on the same chromosome (in cis), and thus not in fact recessive. Includes variants that fulfil the following criteria:',
                        list: [
                            'Non-synonymous',
                            'Slightly rare (minor allele frequency ≤ 0.005 within the cohort and within gnomAD)',
                            'Variant must either be homozygous, or there must be two or more such qualifying variants in the gene in the individual',
                        ],
                    },
                },
                {
                    model: 'syn',
                    definition: {
                        description: 'This model is a negative control and should not be investigated for functional phenotypic associations.',
                        list: [
                            'Synonymous',
                            'Rare (minor allele frequency ≤ 0.0005 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: 'UR',
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and absent from gnomAD)',
                        ],
                    },
                },
                {
                    model: 'URmtr',
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and absent from gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
            ],
        },
    },
    {
        type: {
            value: 'Model for variant-level results',
            rows: [
                {
                    model: 'genotypic',
                    definition: {
                        description: 'Estimates the effect of having an additional copy of the alternate allele (assumed to be the same whether comparing zero to one alleles or one to two alleles). Autosomal genotypes are coded as the number of alternative alleles (0, 1 or 2) and this is modelled as a continuous covariate with one degree of freedom.',
                    },
                },
                {
                    model: 'allelic',
                    definition: {
                        description: 'The units of the test are alleles rather than participants. Compares minor to major alleles, i.e. there are two categories of exposure.',
                    },
                },
                {
                    model: 'dominant',
                    definition: {
                        description: 'Compares participants with one or two minor alleles to those with none. There are two categories of exposure and one degree of freedom.',
                    },
                },
                {
                    model: 'recessive',
                    definition: {
                        description: 'Compares participants with two minor alleles to those with zero or one. There are two categories of exposure and one degree of freedom.',
                    },
                },
            ],
        },
    },
];
export const MODEL_DEFINITIONS_WES_WGS = [
    {
        type: {
            value: 'Model for gene-level coding sequence (CDS) results (collapsing analysis)',
            rows: [
                {
                    model: {
                        name: 'syn',
                    },
                    definition: {
                        description: 'This model is a negative control and should not be investigated for functional phenotypic associations.',
                        list: [
                            'Synonymous',
                            'Rare (minor allele frequency ≤ 0.0005 within the cohort and ≤ 0.00005 within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'ptv',
                    },
                    definition: {
                        list: [
                            'Protein-truncating variant',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'ptv5pct',
                    },
                    definition: {
                        description: 'Care should be taken in the interpretation of this model because it has a higher allele frequency threshold than other models and may therefore be more susceptible to confounding factors.',
                        list: [
                            'Protein-truncating variant',
                            'Less common (minor allele frequency ≤ 0.05 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'UR',
                    },
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Ultra-rare (minor allele frequency ≤ 0.00005 within the cohort and absent from gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'URmtr',
                    },
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Ultra-rare (minor allele frequency ≤ 0.00005 within the cohort and absent from gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'raredmg',
                    },
                    definition: {
                        list: [
                            'Missense variants',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.00005 within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'raredmgmtr',
                    },
                    definition: {
                        list: [
                            'Missense variants',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.00005 within gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'flexdmg',
                    },
                    definition: {
                        list: [
                            'Non-synonymous (including protein-truncating variants, missense variants, in-frame insertions and deletions, splice acceptor variants and splice donor variants)',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'flexnonsynmtr',
                    },
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            'Missense variants must fall within a constrained region (MTR < 0.78 or MTR_centile < 0.5)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'ptvraredmg',
                    },
                    definition: {
                        list: [
                            'Non-synonymous',
                            'Predicted to be damaging (REVEL score ≥ 0.25)',
                            'PTVs must be moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            'Non-PTVs must be rare (minor allele frequency ≤ 0.00025 within the cohort and gnomAD global_raw ≤ 0.00005 and popmax ≤ 0.0005)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'rec',
                    },
                    definition: {
                        description: 'Care should be taken in the interpretation of this model because it has a higher allele frequency threshold than most other models and may therefore be more susceptible to confounding factors. Additionally, be aware that the two qualifying variants in a gene in an individual may be on the same chromosome (in cis), and thus not in fact recessive. Includes variants that fulfil the following criteria:',
                        list: [
                            'Non-synonymous',
                            'Slightly rare (minor allele frequency ≤ 0.01 within the cohort and within gnomAD)',
                            'Variant must either be homozygous, or there must be two or more such qualifying variants in the gene in the individual',
                        ],
                    },
                },
            ],
        },
    },
    {
        type: {
            value: 'Model for gene-level untranslated region (UTR) results (collapsing analysis)',
            description: "3' UTR only (WGS-UTR-3prime), 5' only (WGS-UTR-5prime) and 3' & 5' UTR combined (combined)",
            rows: [
                {
                    model: {
                        name: 'UR',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR variant',
                            'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'URcadd5',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR variant',
                            'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                            'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
                        ],
                    },
                },
                {
                    model: {
                        name: 'flex',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR variant',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'flexcadd5',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR variant',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
                        ],
                    },
                },
                {
                    model: {
                        name: 'flexindel',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR indel',
                            'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                        ],
                    },
                },
                {
                    model: {
                        name: 'rarecadd5',
                    },
                    definition: {
                        list: [
                            'Non-coding UTR variant',
                            'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.0001 in gnomAD)',
                            'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
                        ],
                    },
                },
            ],
        },
    },
    {
        type: {
            value: 'Model for gene-level combined CDS and UTR results (collapsing analysis)',
            rows: [
                {
                    model: {
                        name: 'ptvCDS + URUTR',
                        nameWithSubscript: 'ptv<sub>CDS</sub> + UR<sub>UTR</sub>',
                        description: '(PTV or UTR ultra-rare models combined)',
                    },
                    definition: {
                        listsSeparator: 'OR',
                        lists: [
                            [
                                'Protein-truncating variant',
                                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            ],
                            [
                                'Non-coding UTR variant',
                                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                            ],
                        ],
                    },
                },
                {
                    model: {
                        name: 'ptvCDS + flexUTR',
                        nameWithSubscript: 'ptv<sub>CDS</sub> + flex<sub>UTR</sub>',
                        description: '(PTV or UTR flexible models combined)',
                    },
                    definition: {
                        listsSeparator: 'OR',
                        lists: [
                            [
                                'Protein-truncating variant',
                                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            ],
                            [
                                'Non-coding UTR variant',
                                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                            ],
                        ],
                    },
                },
            ],
        },
    },
];
export const MODEL_DEFINITIONS_COLLECTION = [
    ...MODEL_DEFINITIONS[0].type.rows,
    ...MODEL_DEFINITIONS[1].type.rows,
    {
        model: 'additive',
        definition: {
            description: 'Estimates the effect of having an additional copy of the alternate allele (assumed to be the same whether comparing zero to one alleles or one to two alleles). Autosomal genotypes are coded as the number of alternative alleles (0, 1 or 2) and this is modelled as a continuous covariate with one degree of freedom.',
        },
    },
].reduce((acc, curr) => {
    if (!acc[curr.model]) {
        acc[curr.model] = curr;
    }
    return acc;
}, {});
export const MODEL_DEFINITIONS_WES_WGS_COLLECTION = [
    ...MODEL_DEFINITIONS_WES_WGS[0].type.rows,
    ...MODEL_DEFINITIONS_WES_WGS[1].type.rows,
    ...MODEL_DEFINITIONS_WES_WGS[2].type.rows,
    {
        model: {
            name: 'WGS-CDS-UTR-combined-ptv-flex',
        },
        definition: {
            listsSeparator: 'OR',
            lists: [
                [
                    'Protein-truncating variant',
                    'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                ],
                [
                    'Non-coding UTR variant',
                    'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                ],
            ],
        },
    },
    {
        model: {
            name: 'WGS-CDS-UTR-combined-ptv-UR',
        },
        definition: {
            listsSeparator: 'OR',
            lists: [
                [
                    'Protein-truncating variant',
                    'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                ],
                [
                    'Non-coding UTR variant',
                    'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                ],
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-flex',
        },
        definition: {
            list: [
                "Non-coding 3' UTR variant",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-flexcadd5',
        },
        definition: {
            list: [
                "Non-coding 3' UTR variant",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-flexindel',
        },
        definition: {
            list: [
                "Non-coding 3' UTR indel",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-rarecadd5',
        },
        definition: {
            list: [
                "Non-coding 3' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.0001 in gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-UR',
        },
        definition: {
            list: [
                "Non-coding 3' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-3prime-URcadd5',
        },
        definition: {
            list: [
                "Non-coding 3' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-flex',
        },
        definition: {
            list: [
                "Non-coding 5' UTR variant",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-flexcadd5',
        },
        definition: {
            list: [
                "Non-coding 5' UTR variant",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-flexindel',
        },
        definition: {
            list: [
                "Non-coding 5' UTR indel",
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-rarecadd5',
        },
        definition: {
            list: [
                "Non-coding 5' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.0001 in gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-UR',
        },
        definition: {
            list: [
                "Non-coding 5' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-5prime-URcadd5',
        },
        definition: {
            list: [
                "Non-coding 5' UTR variant",
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-flex',
        },
        definition: {
            list: [
                'Non-coding UTR variant',
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-flexcadd5',
        },
        definition: {
            list: [
                'Non-coding UTR variant',
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-flexindel',
        },
        definition: {
            list: [
                'Non-coding UTR indel',
                'Moderately rare (minor allele frequency ≤ 0.001 within the cohort and within gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-rarecadd5',
        },
        definition: {
            list: [
                'Non-coding UTR variant',
                'Ultra-rare (minor allele frequency ≤ 0.00025 within the cohort and ≤ 0.0001 in gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-UR',
        },
        definition: {
            list: [
                'Non-coding UTR variant',
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
            ],
        },
    },
    {
        model: {
            name: 'WGS-UTR-combined-URcadd5',
        },
        definition: {
            list: [
                'Non-coding UTR variant',
                'Ultra-rare (minor allele frequency ≤ 0.00002 within the cohort and absent from gnomAD)',
                'Combined Annotation Dependent Depletion (CADD) score ≥ 5',
            ],
        },
    },
].reduce((acc, curr) => {
    if (!acc[curr.model.name]) {
        acc[curr.model.name] = curr;
    }
    return acc;
}, {});
